import { Component, Input, OnInit, inject } from '@angular/core';
import { DocumentService } from '@app/services/document.service';

@Component({
  selector: 'lgv-audio-table-item',
  template: `
    @if (url) {
      <audio controls>
        <source [src]="url" type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>
    }
  `,
  standalone: false,
})
export class AudioTableItemComponent implements OnInit {
  private documentService = inject(DocumentService);

  @Input() value: string;

  url: string | undefined;

  async ngOnInit(): Promise<void> {
    const data = await this.documentService.getSignedUrl(this.value);
    this.url = data.url;
  }
}
